<template>
<div class="page_adressAdd">
    <div class="adress_form">
        <div class="item" @click="typePicker = true">
            <div class="item_l">选择类型</div>
            <div class="item_r">
                <van-field v-model="typeName" placeholder="请选择类型" readonly />
            </div>
        </div>
        <div class="item">
            <div class="item_l">姓名</div>
            <div class="item_r">
                <van-field v-model="name" placeholder="请输入姓名" />
            </div>
        </div>
        <div class="item">
            <div class="item_l">银行卡号</div>
            <div class="item_r">
                <van-field v-model="bankCardNo" type="tel" placeholder="请输入银行卡号" />
            </div>
        </div>
        <div class="item" v-if="type==1">
            <div class="item_l">身份证号</div>
            <div class="item_r">
                <van-field v-model="idCardNo" placeholder="请输入身份证号" />
            </div>
        </div>
        <div class="item" v-if="type==1">
            <div class="item_l">手机号</div>
            <div class="item_r">
                <van-field v-model="phoneNum" type="tel" placeholder="请输入手机号" />
            </div>
        </div>
        <div class="item" >
            <div class="item_l">开户行</div>
            <div class="item_r">
                <van-field v-model="bankName" placeholder="请输入开户行" />
            </div>
        </div>
        
    </div>
    <div class="action_wrap">
        <div class="action" @click="saveAddress">保存并使用</div>
    </div>
    <!-- 选择弹层 -->
    <van-popup v-model="typePicker" position="bottom">
        <van-picker show-toolbar :columns="typeList" value-key="name" @cancel="typePicker = false" @confirm="confrimType" />
    </van-popup>
</div>
</template>

<script>
import Vue from 'vue';
import Field from 'vant';
import router from "../../../../.././router";
// import areaList from "./area.js";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent
export default {
    data() {
        return {
            publicPath: process.env.BASE_URL,
            checked: true, // 是否默认
            name: '',
            bankCardNo: '',
            idCardNo: '',
            phoneNum: '',
            bankName: '',
            type: 1,
            typeName: "个人",
            bankId: this.$route.query.bankId,
            token: '',
            typePicker: false,
            isLoading: false,
            typeList: [ // 1个人 2企业
                {
                    type: 1,
                    name: '个人'
                },
                {
                    type: 2,
                    name: '企业'
                },
            ]
        };
    },
    created: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            //设置导航栏
            var params = {
                'data': {
                    'naviTitle': '添加银行卡'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getBankDetail()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            this.token = this.$store.getters.token
            this.getBankDetail()
        }

    },
    methods: {

        getBankDetail() {
            if (this.bankId == null || this.bankId == undefined || this.bankId == '') {
                return
            }
            var params = {
                token: this.token,
                id: this.bankId,
            }
            this.$api.my.bankDetail(params).then(res => {
                if (res.code == 200) {
                    var data = res.result
                    this.name = data.fullname
                    this.bankCardNo = data.card_number
                    this.idCardNo = data.id_card
                    this.phoneNum = data.phone
                    this.bankName = data.opening_bank
                    this.type = data.type
                    if (data.type == 1) {
                        this.typeName = "个人"
                    } else {
                        this.typeName = "企业"
                    }
                } else {
                    this.$toast(res.message)
                }
            })
        },
        saveAddress() {
            if (this.name == null || this.name == undefined || this.name == '') {
                this.$toast('请输入姓名')
                return
            }
            if (this.bankCardNo == null || this.bankCardNo == undefined || this.bankCardNo == '') {
                this.$toast('请输入银行卡号')
                return
            }
            if (this.type == 1) { // 个人
                if (this.idCardNo == null || this.idCardNo == undefined || this.idCardNo == '') {
                    this.$toast('请输入身份证号')
                    return
                }
                if (this.phoneNum == null || this.phoneNum == undefined || this.phoneNum == '') {
                    this.$toast('请输入手机号')
                    return
                }
            }
            if (this.bankName == null || this.bankName == undefined || this.bankName == '') {
                this.$toast('请输入开户行')
                return
            }
            if (this.bankId == null || this.bankId == undefined || this.bankId == '') {
                this.addBankAction()
            } else {
                this.editBankAction()
            }

        },
        addBankAction() {
            if (this.isLoading) {
                return
            }
            var params = {
                token: this.token,
                fullname: this.name,
                card_number: this.bankCardNo,
                type: this.type
            }
            if (this.type == 1) {
                params.id_card = this.idCardNo
                params.phone = this.phoneNum
            }
            params.opening_bank = this.bankName
            this.isLoading = true
            this.$api.my.bankAdd(params).then(res => {
                if (res.code == 200) {
                    this.$toast(res.message)
                    if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                        //返回上级页面
                        var params = {
                            'data': {}
                        }
                        this.$bridge.callhandler('sdjy://public/back', params, (data) => {

                        })
                    } else {
                        this.$router.back()
                    }

                } else {
                    this.$toast(res.message ? res.message : res.msg)
                }
                this.isLoading = false
            })
        },
        editBankAction() {
            if (this.isLoading) {
                return
            }
            var params = {
                token: this.token,
                id: this.bankId,
                fullname: this.name,
                card_number: this.bankCardNo,
                type: this.type
            }
            if (this.type == 1) {
                params.id_card = this.idCardNo
                params.phone = this.phoneNum
            } else {
                params.opening_bank = this.bankName
            }
            console.log(params)
            this.isLoading = true
            this.$api.my.bankEdit(params).then(res => {
                if (res.code == 200) {
                    if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                        //设置导航栏
                        var params = {
                            'data': {}
                        }
                        this.$bridge.callhandler('sdjy://public/back', params, (data) => {

                        })
                    } else {
                        this.$router.back()
                    }
                } else {
                    this.$toast(res.message ? res.message : res.msg)
                }
                this.isLoading = false
            })
        },
        // 确定 选择类型
        confrimType(value) {
            this.type = value.type
            this.typeName = value.name
            this.typePicker = false
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
